//
import UserModel from '@/models/General/GUser'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [
	{
		name: 'g_user_id',
		type: 'autocomplete-model',
		props: {
			itemText: 'hr_employee_name_case',
			itemValue: 'id',
			label: 'Responsable',
			model: UserModel,
			noObject: true,
		},
	},
	{
		name: 'pch_provider_id',
		type: 'autocomplete-model',
		props: {
			itemText: 'business_name',
			itemValue: 'id',
			label: 'Proveedor',
			model: ProviderModel,
			noObject: true,
		},
	},
	{
		name: 'date_payment',
		type: 'date-field',
		props: {
			label: 'Pago',
		},
	},
	{
		name: 'date_payment_min',
		type: 'date-field',
		props: {
			label: 'Desde',
		},
	},
	{
		name: 'date_payment_max',
		type: 'date-field',
		props: {
			label: 'Hasta',
		},
	},
]